/**
 * Normalize a WP REST API / Store API error into a usable Error.
 *
 * WP error response shape:
 *   { code: "woocommerce_rest_error", message: "Foo", data: { status: 400 } }
 *
 * axios surfaces these as err.response.data. We also handle network errors
 * (no response) and unknown shapes.
 */
export function parseWooError(err) {
  // Already a parsed Error — pass through.
  if (err instanceof Error && err.__wooParsed) return err;

  if (err && err.response && err.response.data) {
    const { data } = err.response;
    const message =
      (typeof data === 'string' && data) ||
      data.message ||
      data.code ||
      'Request failed';
    const error = new Error(message);
    error.__wooParsed = true;
    error.code = data.code;
    error.status = err.response.status;
    error.data = data.data;
    return error;
  }

  if (err && err.request) {
    // Request was made but no response came back (network down, CORS, DNS...).
    const error = new Error('Network error — please check your connection');
    error.__wooParsed = true;
    error.code = 'network_error';
    return error;
  }

  if (err instanceof Error) return err;
  return new Error(String(err) || 'Unknown error');
}
